import { createBehavior } from '@area17/a17-behaviors';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import * as FocusTrap from 'focus-trap';

const modal = createBehavior(
  'modal',
  {
    open() {
      this.isOpen = true;
      this.render();
    },
    close() {
      this.isOpen = false;
      this.render();
    },
    render() {
      if (this.isOpen) {
        this.$node.inert = false;
        disableBodyScroll(this.$inner);
        this.$node.classList.add('modal:is-open');
        setTimeout(() => {
          this.focusTrap.activate();
        }, 0);
      } else {
        enableBodyScroll(this.$inner);
        this.focusTrap.deactivate();
        this.$node.classList.remove('modal:is-open');
        this.$node.inert = true;
      }
    },
    onModalLinkClicked(evt) {
      if (evt.detail.id === this.$node.getAttribute('id')) {
        this.open();
      }
    },
    onCloseBtnClick(evt) {
      evt.preventDefault();
      this.close();
    },
  },
  {
    init() {
      this.$inner = this.getChild('inner');
      this.$closeBtns = this.getChildren('close-btn');
      document.addEventListener('modal-link:clicked', this.onModalLinkClicked);

      for (const $closeBtn of this.$closeBtns) {
        $closeBtn.addEventListener('click', this.onCloseBtnClick);
      }

      this.focusTrap = FocusTrap.createFocusTrap(this.$node, {
        onActivate: () => {},
        onDeactivate: () => {
          if (this.isOpen) {
            this.close();
          }
        },
      });
    },
    destroy() {
      document.removeEventListener(
        'modal-link:clicked',
        this.onModalLinkClicked
      );

      for (const $closeBtn of this.$closeBtns) {
        $closeBtn.removeEventListener('click', this.onCloseBtnClick);
      }
    },
  }
);

export default modal;
